import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'
import { FeatureEntitlements } from './featureEntitlements'

export const eversightCompetitiveIntelAccessControl: DomainAccessControlConfig = {
  featureEntitlementIds: [FeatureEntitlements.EversightCompetitiveIntel],
}
